import Vue from 'vue'
import VueRouter from 'vue-router'
import Router from 'vue-router';

// import { isLogged } from '@/utils/auth';
import errorRoutes from './modules/error';
import adminRoutes from './modules/admin';
import Layout from '@/layout';

// import HomeView from '../views/HomeView.vue'
// import DefaultLayout from '../layout/DefaultLayout.vue'
// import CuttingDashboard from '../views/cutting_dashboard/CuttingDashboard.vue'
// import MyAccount from '../views/cutting_dashboard/MyAccount.vue'
// import SignUp from '../views/SignUp.vue'
// import store from '../store'

Vue.use(VueRouter)

export const constantRoutes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '',
    component: Layout,
    redirect: 'dashboard',
    children: [
      // {
      //   path: '/dashboard',
      //   component: () =>
      //     import('@/views/cutting_dashboard/CuttingDashboard'),
      //   name: 'Dashboard',
      //   meta: { title: 'dashboard', icon: 'dashboard', permissions: [], noCache: true },
      // },
      {
        path: '/dashboard',
        name: 'PlanProductCalendar',
        component: () => import('@/views/product/plan_product_calendar/index'),
        meta: { title: 'Lịch kế hoạch', icon: 'dashboard',
          permissions: ['plan_product_bill view_menu'],
          noCache: true },
      },
    ],
  },
  {
    path: '/auth-redirect',
    component: () =>
      import('@/views/login/AuthRedirect'),
    hidden: true,
  },
  {
    path: '/login',
    component: () =>
      import('@/views/login/index'),
    hidden: true,
  },
 
  {
    path: '/about',
    component: Layout,
    hidden: true,

    children: [{
      path: '',
      name: 'About',
      component: () =>
        import('@/views/AboutView'),
      meta: { title: 'About', icon: 'dashboard', permissions: ['dashboard view_menu'], noCache: true },

    }],
  },
  {
    path: '/my-account',
    component: Layout,
    hidden: true,

    children: [{
      path: '',
      component: () =>
        import('@/views/cutting_dashboard/MyAccount'),
      name: 'MyAccount',
      meta: { title: 'myAccount', icon: 'list', permissions: [], noCache: true },

    }],
  },
  errorRoutes,
  {
    path: '/deca',
    component: Layout,
    name: '',
    alwaysShow: true,
    meta: {
      title: 'DeCA',
      icon: 'chart',
    },
    children: [
      {
        path: 'export',
        name: 'DecaExport',
        component: () => import('@/views/deca/index'),
        meta: { title: 'Xuất form DeCA', icon: 'documentation', noCache: true },
      },
    ],
  },
  { path: '*', redirect: '/error/404', hidden: true },


]


export const asyncRoutes = [

  

  {
    path: '/scan',
    component: Layout,
    name: '',
    meta: {
      title: 'Quét mã',
      icon: 'camera',
      permissions: ['scan view_menu'],
    },
    children: [{
      path: 'process',
      name: 'scan',
      component: () =>
        import('@/views/scan/index'),
      meta: { title: 'scan', icon: 'camera',
        permissions: ['scan view_menu'],
        noCache: true },
    }],
  },
  {
    path: '/plan_product',
    component: Layout,
    name: '',
    meta: {
      title: 'Kế hoạch SX',
      icon: 'chart',
      // permissions: ['plan_product_bill view_menu'],
    },
    children: [
        {
          path: 'calendar',
          name: 'PlanProductCalendar',
          component: () => import('@/views/product/plan_product_calendar/index'),
          meta: { title: 'Lịch kế hoạch', icon: 'list',
            permissions: ['plan_product_bill view_menu'],
            noCache: true },
        },
        {
          path: 'bill_list',
          name: 'PlanProductBill',
          component: () => import('@/views/product/plan_product_bill/index'),
          meta: { title: 'Danh sách phiếu', icon: 'list',
            permissions: ['plan_product_bill view_menu'],
            noCache: true },
        },
        {
          path: 'bill_detail', // /:id
          name: 'PlanProductDetail',
          component: () => import('@/views/product/plan_product_detail/index'),
          props: true,
          meta: { title: 'Chi tiết phiếu', icon: 'list',
            permissions: ['plan_product_detail view_menu'],
            noCache: true },
        }
    ],
  },
  {
    path: '/bom_nl',
    component: Layout,
    name: '',
    meta: {
      title: 'BOM Nguyên liệu',
      icon: 'component',
      permissions: ['bom_nl_bill view_menu'],
    },
    children: [
        {
          path: 'bill_list',
          name: 'BomNLBill',
          component: () => import('@/views/bom_nl/bom_nl_bill/index'),
          meta: { title: 'Danh sách phiếu', icon: 'list',
            permissions: ['bom_nl_bill view_menu'],
            noCache: true },
        },
        {
          path: 'bill_detail', // /:id
          name: 'BomNLDetail',
          component: () => import('@/views/bom_nl/bom_nl_detail/index'),
          props: true,
          meta: { title: 'Chi tiết phiếu', icon: 'list',
            permissions: ['bom_nl_detail view_menu'],
            noCache: true },
        }
    ],
  },
  {
    path: '/dissect_diagram',
    component: Layout,
    name: '',
    meta: {
      title: 'Tác nghiệp Sơ đồ',
      icon: 'edit',
      // permissions: ['plan_product_bill view_menu'],
    },
    children: [
        {
          path: 'bill_list',
          name: 'DissectDiagramBill',
          component: () => import('@/views/diagram/dissect_diagram_bill/index'),
          meta: { title: 'Danh sách phiếu', icon: 'list',
            permissions: ['dissect_diagram_bill view_menu'],
            noCache: true },
        },
        {
          path: 'bill_detail', // /:id
          name: 'DissectDiagramDetail',
          component: () => import('@/views/diagram/dissect_diagram_detail/index'),
          props: true,
          meta: { title: 'Chi tiết phiếu', icon: 'list',
            permissions: ['dissect_diagram_detail view_menu'],
            noCache: true },
        },
        {
          path: 'staging_bill_detail', // /:id
          name: 'StagingDissectDiagramDetail',
          component: () => import('@/views/diagram/staging_dissect_diagram_detail/index'),
          props: true,
          hidden: true,  // an khoi sidebar - chi navigate tu code (vd: bam vao phieu VES trong Danh sach)
          meta: { title: 'Chi tiết phiếu (Dàn)', icon: 'list',
            permissions: ['dissect_diagram_detail view_menu'],
            noCache: true },
        }
    ],
  },

  {
    path: '/frame_dissect',
    component: Layout,
    name: '',
    meta: {
      title: 'Tác nghiệp Rập',
      icon: 'layout',
      permissions: ['frame_dissect_bill view_menu'],
    },
    children: [
        {
          path: 'bill_list',
          name: 'FrameDissectBill',
          component: () => import('@/views/frame_dissect/frame_dissect_bill/index'),
          meta: { title: 'Danh sách phiếu', icon: 'list',
            permissions: ['frame_dissect_bill view_menu'],
            noCache: true },
        },
        {
          path: 'bill_detail', // /:id
          name: 'FrameDissectDetail',
          component: () => import('@/views/frame_dissect/frame_dissect_detail/index'),
          props: true,
          meta: { title: 'Chi tiết phiếu', icon: 'list',
            permissions: ['frame_dissect_detail view_menu'],
            noCache: true },
        }
    ],
  },

  {
    path: '/cutting_process_log',
    component: Layout,
    name: '',
    meta: {
      title: 'Thanh toán bàn cắt',
      icon: 'scissors',
      permissions: ['cutting_process_log_bill view_menu'],
    },
    children: [
        {
          path: 'bill_list',
          name: 'CuttingProcessLogBill',
          component: () => import('@/views/cutting_process_log/cutting_process_log_bill/index'),
          meta: { title: 'Danh sách phiếu', icon: 'list',
            permissions: ['cutting_process_log_bill view_menu'],
            noCache: true },
        },
        {
          path: 'bill_detail', // /:id
          name: 'CuttingProcessLogDetail',
          component: () => import('@/views/cutting_process_log/cutting_process_log_detail/index'),
          props: true,
          meta: { title: 'Chi tiết phiếu', icon: 'list',
            permissions: ['cutting_process_log_detail view_menu'],
            noCache: true },
        },
        {
          path: 'repair_bill_detail',
          name: 'RepairComponentDetail',
          component: () => import('@/views/repair_component/repair_component_detail/index'),
          props: true,
          meta: { title: 'Phiếu thay thân', icon: 'list',
            permissions: ['cutting_process_log_detail view_menu'],
            noCache: true },
        }
    ],
  },
  {
    path: '/semi_finished_tag',
    component: Layout,
    name: '',
    meta: {
      title: 'Quản lý BTP',
      icon: 'shopping',
      permissions: ['semi_finished_tag view_menu'],
    },
    children: [
        {
          path: 'card_list',
          name: 'SemiFinishedTagList',
          component: () => import('@/views/semi_finished_tag/list/index'),
          meta: { title: 'Danh sách thẻ', icon: 'list',
            permissions: ['semi_finished_tag view_menu'],
            noCache: true },
        },
        {
          path: 'process',
          name: 'SemiFinishedTagScan',
          component: () =>
            import('@/views/semi_finished_tag/scan/index'),
          meta: { title: 'Quét thẻ', icon: 'station',
            permissions: ['semi_finished_tag view_menu'],
            noCache: true },
        },
        {
           path: 'fabric_tree',
           name: 'FabricTree',
           component: () =>
             import('@/views/fabrics/list/index'),
           meta: { title: 'Cây vải', icon: 'station',
             permissions: ['semi_finished_tag view_menu'],
             noCache: true },
         }
    ],
  },

  {
    path: '/semi_finished_export',
    component: Layout,
    name: '',
    meta: {
      title: 'Xuất BTP gia công ngoài',
      icon: 'shopping',
    },
    children: [
        {
          path: 'bill_list',
          name: 'SemiFinishedExportBillList',
          component: () => import('@/views/semi_finished_export/bill_list/index'),
          meta: { title: 'Phiếu xuất GC ngoài', icon: 'list',
            noCache: true },
        },
        {
          path: 'bill_detail',
          name: 'SemiFinishedExportBillDetail',
          hidden: true,
          component: () => import('@/views/semi_finished_export/bill_detail/index'),
          meta: { title: 'Chi tiết phiếu xuất GC', icon: 'form',
            noCache: true,
            activeMenu: '/semi_finished_export/bill_list' },
        }
    ],
  },

  {
    path: '/fabric_receive',
    component: Layout,
    name: '',
    alwaysShow: true,
    meta: {
      title: 'Vải tại tổ cắt',
      icon: 'shopping',
    },
    children: [
      {
        path: 'scan',
        name: 'FabricReceiveScan',
        component: () => import('@/views/fabric_receive/scan/index'),
        meta: { title: 'Quét nhận vải', icon: 'camera',
          permissions: ['fabric_receive_scan view_menu'],
          noCache: true },
      },
      {
        path: 'inventory',
        name: 'FabricReceiveInventory',
        component: () => import('@/views/fabric_receive/inventory/index'),
        meta: { title: 'Tồn kho tổ cắt', icon: 'list',
          permissions: ['fabric_receive_inventory view_menu'],
          noCache: true },
      },
    ],
  },

  {
    path: '/semi_finished_import',
    component: Layout,
    name: '',
    meta: {
      title: 'Nhận BTP gia công ngoài',
      icon: 'shopping',
    },
    children: [
        {
          path: 'bill_list',
          name: 'SemiFinishedImportBillList',
          component: () => import('@/views/semi_finished_import/bill_list/index'),
          meta: { title: 'Nhận GC (quét nhập)', icon: 'list',
            noCache: true },
        },
        {
          path: 'bill_detail',
          name: 'SemiFinishedImportBillDetail',
          hidden: true,
          component: () => import('@/views/semi_finished_import/bill_detail/index'),
          meta: { title: 'Chi tiết phiếu nhập GC', icon: 'form',
            noCache: true,
            activeMenu: '/semi_finished_import/bill_list' },
        },
        {
          path: 'reports',
          name: 'GCOutsourceReport',
          component: () => import('@/views/semi_finished_import/reports/index'),
          meta: { title: 'Báo cáo Xuất-Nhập-Tồn GC', icon: 'chart',
            noCache: true },
        }
    ],
  },

  {
    path: '/cutting_product_plan',
    component: Layout,
    name: '',
    meta: {
      title: 'Phiếu ra hàng',
      icon: 'clipboard',
      permissions: ['cutting_product_plan_bill view_menu'],

    },
    children: [
        {
          path: 'bill_list',
          name: 'CuttingProductPlanBill',
          component: () => import('@/views/cutting_dashboard/cutting_product_plan_bill/index'),
          meta: { title: 'Danh sách phiếu', icon: 'list',
            permissions: ['cutting_product_plan_bill view_menu'],
            noCache: true },
        },
        {
          path: 'detail', // /:id
          name: 'CuttingProductPlanDetail',
          component: () => import('@/views/cutting_dashboard/cutting_product_plan_detail/index'),
          props: true,
          meta: { title: 'Chi tiết phiếu', icon: 'list',
            permissions: ['cutting_product_plan_detail view_menu'],
            noCache: true },
        }
    ],
  },
  {
    path: '/tracking',
    component: Layout,
    name: '',
    meta: {
      title: 'Truy xuất nguồn gốc',
      icon: 'camera',
      permissions: ['tracking view_menu'],
    },
    children: [{
      path: 'process',
      name: 'Tracking',
      component: () =>
        import('@/views/tracking/index'),
      meta: { title: 'Truy xuất nguồn gốc', icon: 'camera',
        permissions: ['tracking view_menu'],
        noCache: true },
    }],
  },
  {
    path: '/factory',
    component: Layout,
    name: '',
    meta: {
      title: 'Quản lý xí nghiệp',
      icon: 'station',
      permissions: ['factory_list view_menu'],
    },
    children: [
      {
        path: 'list',
        name: 'factories',
        component: () =>
          import('@/views/factory/index'),
        meta: { title: 'Danh sách xí nghiệp', icon: 'station',
          permissions: ['factory_list view_menu'],
          noCache: true },
      },
      {
        path: 'cut_team',
        name: 'cut-teams',
        component: () =>
          import('@/views/cut_team/index'),
        meta: { title: 'Quản lý tổ may', icon: 'peoples',
          permissions: ['cut_team_list view_menu'],
          noCache: true },
      }
    ],
  },
  adminRoutes,

];

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  base: '', // process.env.MIX_LARAVUE_PATH,
  routes: constantRoutes,
});

const router = createRouter();

// Ghi đè phương thức push để tránh lỗi NavigationDuplicated
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => err);
};

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })

export function resetRouter() {
  console.log("trigger reset router");
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
  console.log("router.matcher: ");
  console.log(router.matcher.getRoutes());

}

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requireLogin) && !store.state.isAuthenticated) {
//     next('/login')
//   } else {
//     next()
//   }
// })

export default router
